import React from 'react';

const IconRemove = () => {
  return (
    <svg className="close-button-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 12" enableBackground="new 0 0 12 12" xmlSpace="preserve">
      <path
        d="M1.201,10.798c0.27,0.27,0.707,0.27,0.976,0L6,6.976l3.822,3.822c0.27,0.27,0.707,0.27,0.976,0
        c0.27-0.27,0.27-0.707,0-0.976L6.977,6l3.822-3.823c0.27-0.269,0.27-0.707,0-0.976c-0.27-0.269-0.707-0.269-0.976,0L6,5.024
        L2.178,1.201c-0.269-0.269-0.707-0.269-0.976,0c-0.269,0.269-0.269,0.707,0,0.976L5.024,6L1.201,9.822
        C0.932,10.092,0.932,10.529,1.201,10.798z"
      />
    </svg>
  );
};

export default IconRemove;
